export default __webpack_public_path__ + "static/media/value1.77209732.png";